module.exports = __webpack_public_path__ + "static/media/Developmenticon01@3x.c909b071.png";